module.exports = __webpack_public_path__ + "img/proyectos2.de6a04d7.png";